import React from 'react'


import { FormInputContainer, Input } from './styles'
import { FieldHelperText } from '../FieldHelperText'
import { FieldLabel } from '../FieldLabel'

interface Props extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  errorMessage?: string
  label?: string
  isRequired?: boolean
  isDisabled?: boolean
}

export function FormTextArea({
  label,
  errorMessage,
  isRequired = false,
  isDisabled = false,
  ...rest
}: Props) {
  const isInvalid = !!errorMessage

  return (
    <FormInputContainer>
      <FieldLabel isRequired={isRequired} isInvalid={isInvalid}>
        {label}
      </FieldLabel>
      <Input
        isInvalid={isInvalid}
        isDisabled={isDisabled}
        disabled={isDisabled}
        rows={4}
        {...rest}
      />
      <FieldHelperText isInvalid={isInvalid}>{errorMessage}</FieldHelperText>
    </FormInputContainer>
  )
}
